import React, { useEffect, useState } from "react";

import Api from "../Api";
import { StatusChangeSection } from "../component";
import { StatusFlowTransition, StatusItem } from "../utils/interface";

const StatusChange: React.FC<{
  statusId: number;
  statusFlowId: number;
  handleUpdateStatus: (statusId: number) => void;
}> = ({
  statusId,
  statusFlowId,
  handleUpdateStatus
}) => {
  const api = Api();

  const [statusItem, setStatusItem] = useState<StatusItem>();
  const [statusFlowTransitions, setStatusFlowTransitions] = useState<StatusFlowTransition[]>([]);

  useEffect(() => {
    if (statusId) {
      api.status.getStatusItem(statusId).then((response: any) => {
        setStatusItem(response.result.data);
      });
    }
  }, [statusId])
  useEffect(() => {
    if (statusFlowId) {
      api.status.getStatusFlowTransitions(statusFlowId, statusId).then((response: any) => {
        setStatusFlowTransitions(response.result.data);
      })
    }
  }, [statusFlowId, statusId])

  return (<>
    {statusItem && (
      <StatusChangeSection
        statusItem={statusItem}
        statusFlowTransitions={statusFlowTransitions}
        updateStatus={handleUpdateStatus}
      />
    )}
  </>);
};

export default StatusChange;
